export const PHONE_DISPLAY = "07494 805669";
export const PHONE_TEL = "tel:+447494805669";
export const WHATSAPP_NUMBER = "447494805669";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}${
    message ? `?text=${encodeURIComponent(message)}` : ""
  }`;

export const DEFAULT_WA_MSG =
  "Hi Motion Tyres — I need help with a tyre. Can you fit one for me?";

export const BRANDS = [
  "MICHELIN",
  "PIRELLI",
  "CONTINENTAL",
  "GOODYEAR",
  "DUNLOP",
  "BRIDGESTONE",
  "AVON",
  "HANKOOK",
];

export const IMG = {
  hero: "https://images.unsplash.com/photo-1706017376160-18a4a89d0829?q=80&w=1920&auto=format&fit=crop",
  heroAlt:
    "https://images.unsplash.com/photo-1623564493214-6137dff043ad?q=80&w=1920&auto=format&fit=crop",
  fitting:
    "https://images.unsplash.com/photo-1613214149922-f1809c99b414?q=80&w=1600&auto=format&fit=crop",
  fitting2:
    "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?q=80&w=1600&auto=format&fit=crop",
  puncture:
    "https://images.unsplash.com/photo-1599082267768-4815b2ea6bd2?q=80&w=1600&auto=format&fit=crop",
  alignment:
    "https://images.unsplash.com/photo-1652852592938-15bf8c50ab6d?q=80&w=1600&auto=format&fit=crop",
  alignment2:
    "https://images.unsplash.com/photo-1669437921238-76df6d82668a?q=80&w=1600&auto=format&fit=crop",
  summer:
    "https://images.unsplash.com/photo-1776406166571-768271862c3d?q=80&w=1600&auto=format&fit=crop",
  winter:
    "https://images.unsplash.com/photo-1610635974060-9284319ceac9?q=80&w=1600&auto=format&fit=crop",
  seasonal:
    "https://images.unsplash.com/photo-1694787683490-0b9dff60d8ab?q=80&w=1600&auto=format&fit=crop",
  detail:
    "https://images.unsplash.com/photo-1616788902258-138db56fe7e5?q=80&w=1600&auto=format&fit=crop",
  rim: "https://images.unsplash.com/photo-1444947295498-07f60c19a4ff?q=80&w=1600&auto=format&fit=crop",
  coventry:
    "https://images.unsplash.com/photo-1639088653566-0434c047faed?q=80&w=1600&auto=format&fit=crop",
  london:
    "https://images.unsplash.com/photo-1486299267070-83823f5448dd?q=80&w=1600&auto=format&fit=crop",
  reading:
    "https://images.unsplash.com/photo-1700866501289-8c8c710e776c?q=80&w=1600&auto=format&fit=crop",
  bristol:
    "https://images.unsplash.com/photo-1597079013069-bd1681f7454f?q=80&w=1600&auto=format&fit=crop",
  cardiff:
    "https://images.unsplash.com/photo-1580987502658-6b7345783e6f?q=80&w=1600&auto=format&fit=crop",
  cambridge:
    "https://images.unsplash.com/photo-1623632306901-e509641e7191?q=80&w=1600&auto=format&fit=crop",
  northampton:
    "https://images.unsplash.com/photo-1626010448970-11fba7e71034?q=80&w=1600&auto=format&fit=crop",
  oxford:
    "https://images.unsplash.com/photo-1619141602633-03b32e362945?q=80&w=1600&auto=format&fit=crop",
  southampton:
    "https://images.unsplash.com/photo-1695072798279-5250cc0e053e?q=80&w=1600&auto=format&fit=crop",
  bournemouth:
    "https://images.unsplash.com/photo-1655578985146-4782d639f4f5?q=80&w=1600&auto=format&fit=crop",
  bath:
    "https://images.unsplash.com/photo-1653231905678-1371a378f3f3?q=80&w=1600&auto=format&fit=crop",
  peterborough:
    "https://images.unsplash.com/photo-1516284446131-de6864017a84?q=80&w=1600&auto=format&fit=crop",
};
